import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = { schoolForm: { lotteryNumber: number | null } | null };

export const buildLotteryNumberColumnDef = <
  T extends Row
>(): ColumnDefWithTooltip<T> => ({
  id: ColumnId.LotteryNumber,
  header: "Lottery Number",
  accessorFn: (row: T) => row.schoolForm?.lotteryNumber,
  enableSorting: false,
});
